<template>
    <v-card class="app-card">
        <fude-table :settings="settings" class="educations">
             <span slot="year" slot-scope="{ item }">
                <span>{{item.year}}</span>
             </span>
            <span slot="level" slot-scope="{ item }">
                 <span>{{item.education_level_name}}</span>
             </span>
            <span slot="institution" slot-scope="{ item }">
                <span>{{item.name}}</span>
            </span>
            <span slot="description" slot-scope="{ item }">
                <span>{{item.description}}</span>
            </span>
        </fude-table>
    </v-card>
</template>

<script>
    import Dialog from './education-dialog';

    export default {
        name: "app-resume-educations",
        props : {
            model : {}
        },
        computed : {
            settings() {
                let result = {
                    search: false,
                        pagination : false,
                    title : { text : 'Образование ({0})' },
                    items: this.model.educations,
                        headers : {
                    year: { text : { text : 'Год окончания' }, sortable : false },
                    level: { text : { text : 'Уровень' }, sortable : false },
                    institution: { text : { text : 'Учебное заведение' }, sortable : false },
                    description: { text : { text : 'Описание' }, sortable : false }
                },
                    actions: {
                        dialog : Dialog,
                            fullScreen : false,
                            model : (item) => {
                            item = item || { };
                            item = this.$clone(item);
                            return item;
                        },
                            add : {
                            title : () => 'Добавление образования'
                        },
                        edit : {
                            title : () => 'Редактирование образования'
                        },
                        remove : {
                            title : (item) => `Удалить образование?`
                        },
                    }
                };

                result.items = this.model.educations;

                return result;
            }
        }
    }
</script>

<style lang="less">
    .fude-table.educations {
        background: transparent !important;
        box-shadow: none;
        .theme--light.v-table thead th {
            color: black;
        }
        .v-datatable {
            background: transparent !important;
        }
        .fude-table-data{
            padding: 24px;
        }
    }
</style>